function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var Transaction = require('../../../lib/saito/transaction')["default"];
var ModTemplate = require('../../../lib/templates/modtemplate');
var JSON = require('json-bigint');
var Invite = require('./ui/invite');
var SaitoOverlay = require('../../../lib/saito/ui/saito-overlay/saito-overlay');
var GameInvitationLink = require('../../../lib/saito/ui/modals/saito-link/saito-link');
module.exports = {
  createPseudoTransaction: function createPseudoTransaction(game) {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _game$step;
      var game_tx, msg;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.app.wallet.createUnsignedTransaction(_this.publicKey, BigInt(0), BigInt(0));
          case 1:
            game_tx = _context.v;
            if (game.accepted) {
              game.accepted.forEach(function (player) {
                game_tx.addTo(player);
                game_tx.addFrom(player);
              });
            } else {
              game_tx.addFrom(_this.publicKey);
              game_tx.addTo(_this.publicKey);
            }
            msg = {
              //ts
              module: 'Arcade',
              request: 'loaded',
              //will be overwritten as "active" when added
              game: game.module,
              options: game.options,
              players_needed: game.players_needed,
              players: game.accepted,
              players_sigs: [],
              //Only used to verify cryptology when initializing the game
              originator: game.originator,
              //winner: game.winner,
              step: game === null || game === void 0 || (_game$step = game.step) === null || _game$step === void 0 ? void 0 : _game$step.game,
              timestamp: game === null || game === void 0 ? void 0 : game.timestamp
            };
            game_tx.signature = game.id;
            game_tx.msg = msg;
            return _context.a(2, game_tx);
        }
      }, _callee);
    }))();
  },
  onPeerHandshakeComplete: function onPeerHandshakeComplete(app, peer) {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var newtx, id, record;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (app.BROWSER) {
              _context2.n = 3;
              break;
            }
            _context2.n = 1;
            return _this2.app.wallet.createUnsignedTransactionWithDefaultFee();
          case 1:
            newtx = _context2.v;
            newtx.msg = {
              module: 'Arcade',
              request: 'arcade update peer status',
              data: {
                publickey: peer.publicKey,
                status: 'online'
              }
            };
            _context2.n = 2;
            return newtx.sign();
          case 2:
            _this2.notifyPeers(newtx);
            for (id in _this2.invites) {
              record = _this2.invites[id];
              if (record.tx.from[0].publicKey == peer.publicKey) {
                record.is_sender_reachable = true;
              }
            }
            return _context2.a(2);
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }))();
  },
  onPeerServiceUp: function onPeerServiceUp(app, peer) {
    var _arguments = arguments,
      _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var service, arcade_self;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            service = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
            arcade_self = _this3;
            if (service.service == 'arcade') {
              _this3.app.network.sendRequestAsTransaction('arcade invite list', {}, /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(txs) {
                  var _iterator, _step, _loop, game_id, game_module_slug, _yield$arcade_self$re, game_tx, from_archive, invite, _t;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.p = _context4.n) {
                      case 0:
                        if (!((txs === null || txs === void 0 ? void 0 : txs.length) > 0)) {
                          _context4.n = 8;
                          break;
                        }
                        _iterator = _createForOfIteratorHelper(txs);
                        _context4.p = 1;
                        _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                          var _game_tx$msg;
                          var serial_tx, game_tx, status, _arcade_self$app$opti, exists_locally, msg, game_added;
                          return _regenerator().w(function (_context3) {
                            while (1) switch (_context3.n) {
                              case 0:
                                serial_tx = _step.value;
                                game_tx = new Transaction();
                                game_tx.deserialize_from_web(app, serial_tx);
                                status = game_tx === null || game_tx === void 0 || (_game_tx$msg = game_tx.msg) === null || _game_tx$msg === void 0 ? void 0 : _game_tx$msg.request;
                                if (!arcade_self.isMyGame(game_tx)) {
                                  _context3.n = 1;
                                  break;
                                }
                                exists_locally = (_arcade_self$app$opti = arcade_self.app.options) === null || _arcade_self$app$opti === void 0 || (_arcade_self$app$opti = _arcade_self$app$opti.games) === null || _arcade_self$app$opti === void 0 ? void 0 : _arcade_self$app$opti.find(function (g) {
                                  return g.id === game_tx.signature;
                                });
                                if (exists_locally) {
                                  _context3.n = 1;
                                  break;
                                }
                                //
                                // Same window as purge() INVITE_CUTOFF — keep my open invites
                                // visible for as long as others see them.
                                //
                                msg = game_tx.returnMessage();
                                if (!(Date.now() - msg.timestamp > 2000000)) {
                                  _context3.n = 1;
                                  break;
                                }
                                return _context3.a(2, 1);
                              case 1:
                                game_added = arcade_self.addInviteRecord(game_tx); //Game is marked as "active" but we didn't already add it from our app.options file...
                                if (status == 'active' && game_added && arcade_self.isMyGame(game_tx)) {
                                  game_tx.msg.game_id = game_tx.signature;
                                  arcade_self.receiveAcceptTransaction(game_tx);
                                }
                              case 2:
                                return _context3.a(2);
                            }
                          }, _loop);
                        });
                        _iterator.s();
                      case 2:
                        if ((_step = _iterator.n()).done) {
                          _context4.n = 5;
                          break;
                        }
                        return _context4.d(_regeneratorValues(_loop()), 3);
                      case 3:
                        if (!_context4.v) {
                          _context4.n = 4;
                          break;
                        }
                        return _context4.a(3, 4);
                      case 4:
                        _context4.n = 2;
                        break;
                      case 5:
                        _context4.n = 7;
                        break;
                      case 6:
                        _context4.p = 6;
                        _t = _context4.v;
                        _iterator.e(_t);
                      case 7:
                        _context4.p = 7;
                        _iterator.f();
                        return _context4.f(7);
                      case 8:
                        if (!arcade_self.app.browser.returnURLParameter('game_id')) {
                          _context4.n = 10;
                          break;
                        }
                        game_id = arcade_self.app.browser.returnURLParameter('game_id');
                        try {
                          game_id = decodeURIComponent(game_id);
                        } catch (_) {}
                        game_module_slug = arcade_self.app.browser.returnURLParameter('game');
                        _context4.n = 9;
                        return arcade_self.returnGameInvite(game_id, game_module_slug);
                      case 9:
                        _yield$arcade_self$re = _context4.v;
                        game_tx = _yield$arcade_self$re.game_tx;
                        from_archive = _yield$arcade_self$re.from_archive;
                        if (game_tx && !from_archive && game_tx.msg.request !== 'cancel' && game_tx.msg.request !== 'closed') {
                          arcade_self.addInviteRecord(game_tx);
                          if (arcade_self.isAvailableGame(game_tx)) {
                            game_tx.msg.options.desired_opponent_publickey = arcade_self.publicKey;
                            arcade_self.removeInviteRecord(game_tx.signature);
                            arcade_self.addInviteRecord(game_tx);
                          }
                          invite = new Invite(arcade_self.app, arcade_self, null, null, game_tx, arcade_self.publicKey);
                          arcade_self.render('lounge_overlay', {
                            invite_data: invite.invite_data
                          });
                        } else {
                          arcade_self.render('lounge_overlay', {
                            game_id: game_id,
                            observer_has_archive_data: !!game_tx,
                            game_module_slug: game_module_slug || null
                          });
                        }
                        window.history.replaceState('', '', "/arcade/");
                      case 10:
                        _this3.renderInvites();
                        app.connection.emit('arcade-data-loaded');
                      case 11:
                        return _context4.a(2);
                    }
                  }, _callee3, null, [[1, 6, 7, 8]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            }

            //
            // I am going to comment this out for a bit, because I don't know if we still need it
            // It was "broken" and so not working for... a while
            // The idea is to query the last 10 moves of all your saved games in case you didn't get them
            // on/off chain and then rerun them
            // I think it might be essential for asynchronous gaming since we don't know that we will
            // get lite blocks going back too far
            //
            if (service.service === 'archive') {
              /*for (let game of this.app.options.games) {
                if (game?.over) {
                  continue;
                }
                 let game_mod = this.app.modules.returnModule(game.module);
                 if (!game_mod) {
                  continue;
                }
                 this.app.storage.loadTransactions(
                  {
                    field1: game.module,
                    field4: game.id
                  },
                  async (txs) => {
                    if (txs?.length > 0) {
                      for (let i = txs.length - 1; i >= 0; i--) {
                        // arcade
                        await this.onConfirmation(-1, txs[i], 0);
                         // game mod
                        await game_mod.onConfirmation(-1, txs[i], 0);
                      }
                    }
                  },
                  peer
                );
              }*/
            }
          case 1:
            return _context5.a(2);
        }
      }, _callee4);
    }))();
  },
  returnGameInvite: function returnGameInvite(game_id, game_module) {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var _this4$invites$game_i, _this4$invites$game_i2, _this4$app$options;
      var game_tx, from_archive, opt;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            try {
              game_id = decodeURIComponent(game_id);
            } catch (_) {}
            game_tx = (_this4$invites$game_i = (_this4$invites$game_i2 = _this4.invites[game_id]) === null || _this4$invites$game_i2 === void 0 ? void 0 : _this4$invites$game_i2.tx) !== null && _this4$invites$game_i !== void 0 ? _this4$invites$game_i : null;
            from_archive = false;
            if (!(!game_tx && (_this4$app$options = _this4.app.options) !== null && _this4$app$options !== void 0 && (_this4$app$options = _this4$app$options.games) !== null && _this4$app$options !== void 0 && _this4$app$options.length)) {
              _context6.n = 2;
              break;
            }
            opt = _this4.app.options.games.find(function (g) {
              return g.id === game_id;
            });
            if (!opt) {
              _context6.n = 2;
              break;
            }
            _context6.n = 1;
            return _this4.createPseudoTransaction(opt);
          case 1:
            game_tx = _context6.v;
          case 2:
            if (!(!game_tx && game_module)) {
              _context6.n = 4;
              break;
            }
            _context6.n = 3;
            return new Promise(function (resolve) {
              _this4.app.storage.loadTransactions({
                field1: game_module,
                field4: game_id,
                order_by: 'field5',
                order: 'ASC',
                limit: 1
              }, function (txs) {
                var tx = txs && txs.length ? txs[0] : null;
                resolve(tx || null);
              });
            });
          case 3:
            game_tx = _context6.v;
            if (game_tx) {
              from_archive = true;
            }
          case 4:
            return _context6.a(2, {
              game_tx: game_tx,
              from_archive: from_archive
            });
        }
      }, _callee5);
    }))();
  },
  onConfirmation: function onConfirmation(blk, tx, conf) {
    var _this5 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var txmsg, arcade_self, _txmsg$step, step, _t2;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            txmsg = tx.returnMessage();
            arcade_self = _this5.app.modules.returnModule('Arcade');
            if (!(Number(conf) == 0)) {
              _context7.n = 14;
              break;
            }
            _context7.p = 1;
            if (!(txmsg.module === 'Arcade')) {
              _context7.n = 8;
              break;
            }
            if (!_this5.hasSeenTransaction(tx, blk)) {
              _context7.n = 2;
              break;
            }
            return _context7.a(2);
          case 2:
            if (!(txmsg.request === 'open' || txmsg.request === 'private')) {
              _context7.n = 3;
              break;
            }
            _context7.n = 3;
            return arcade_self.receiveOpenTransaction(tx, blk);
          case 3:
            if (!(txmsg.request == 'join')) {
              _context7.n = 4;
              break;
            }
            _context7.n = 4;
            return arcade_self.receiveJoinTransaction(tx);
          case 4:
            if (!(txmsg.request == 'leave')) {
              _context7.n = 5;
              break;
            }
            _context7.n = 5;
            return arcade_self.receiveLeaveTransaction(tx);
          case 5:
            if (!(txmsg.request == 'cancel')) {
              _context7.n = 6;
              break;
            }
            _context7.n = 6;
            return arcade_self.receiveCancelTransaction(tx);
          case 6:
            if (!(txmsg.request === 'accept')) {
              _context7.n = 7;
              break;
            }
            _context7.n = 7;
            return arcade_self.receiveAcceptTransaction(tx);
          case 7:
            _context7.n = 12;
            break;
          case 8:
            if (!(txmsg.request === 'stopgame')) {
              _context7.n = 9;
              break;
            }
            _context7.n = 9;
            return arcade_self.receiveCloseTransaction(tx);
          case 9:
            if (!(txmsg.request === 'gameover')) {
              _context7.n = 10;
              break;
            }
            _context7.n = 10;
            return arcade_self.receiveGameOverTransaction(tx);
          case 10:
            if (!(txmsg.request === 'game')) {
              _context7.n = 11;
              break;
            }
            _context7.n = 11;
            return arcade_self.receiveGameStepTransaction(tx);
          case 11:
            if (txmsg.request === 'JOIN' || txmsg.request === 'LEAVE' || txmsg.request === 'CANCEL') {
              arcade_self.receiveGametableMeta(tx);
            }

            //
            // Archive game overs for async / observer mode to work
            //
            if (_this5.app.BROWSER) {
              _context7.n = 12;
              break;
            }
            step = (txmsg === null || txmsg === void 0 || (_txmsg$step = txmsg.step) === null || _txmsg$step === void 0 ? void 0 : _txmsg$step.game) || txmsg.step || null;
            if (step) {
              step = String(step).padStart(5, '0');
            }
            _context7.n = 12;
            return _this5.app.storage.saveTransaction(tx, {
              field4: txmsg.game_id,
              field5: step,
              field5_sort: 1
            }, 'localhost');
          case 12:
            //
            // only servers notify lite-clients
            // Added this so cross-network onChain messages can duplicate quickly
            //
            if (_this5.app.BROWSER == 0 && _this5.app.SPVMODE == 0) {
              _this5.notifyPeers(tx);
            }
            _context7.n = 14;
            break;
          case 13:
            _context7.p = 13;
            _t2 = _context7.v;
          case 14:
            return _context7.a(2);
        }
      }, _callee6, null, [[1, 13]]);
    }))();
  },
  /////////////////////////////
  // HANDLE PEER TRANSACTION //
  /////////////////////////////
  //
  // handles off-chain transactions, packaged as data by Relay module
  handlePeerTransaction: function handlePeerTransaction(app) {
    var _arguments2 = arguments,
      _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var newtx, peer, mycallback, message, requester, txs, peers, id, record, g, tx, txmsg, _t3, _t4;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            newtx = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : null;
            peer = _arguments2.length > 2 ? _arguments2[2] : undefined;
            mycallback = _arguments2.length > 3 && _arguments2[3] !== undefined ? _arguments2[3] : null;
            if (!(newtx == null)) {
              _context8.n = 1;
              break;
            }
            return _context8.a(2, 0);
          case 1:
            message = newtx.returnMessage();
            requester = peer.publicKey;
            if (!(message.request === 'arcade invite list')) {
              _context8.n = 7;
              break;
            }
            _this6.purge();
            txs = [];
            _context8.n = 2;
            return app.network.getPeers();
          case 2:
            peers = _context8.v;
            _t3 = _regeneratorKeys(_this6.invites);
          case 3:
            if ((_t4 = _t3()).done) {
              _context8.n = 6;
              break;
            }
            id = _t4.value;
            record = _this6.invites[id];
            if (!(record.is_sender_reachable !== true && requester != record.tx.from[0].publicKey)) {
              _context8.n = 4;
              break;
            }
            return _context8.a(3, 3);
          case 4:
            if (!(record.status === 'closed' || record.status === 'over')) {
              _context8.n = 5;
              break;
            }
            return _context8.a(3, 3);
          case 5:
            g = record.tx;
            txs.push(g.serialize_to_web(_this6.app));
            _context8.n = 3;
            break;
          case 6:
            if (!mycallback) {
              _context8.n = 7;
              break;
            }
            mycallback(txs);
            return _context8.a(2, 1);
          case 7:
            if (!(message.request === 'arcade clear invite')) {
              _context8.n = 8;
              break;
            }
            _this6.removeInviteRecord(message.data.game_id);
            return _context8.a(2, 1);
          case 8:
            if (!(message !== null && message !== void 0 && message.data && (message === null || message === void 0 ? void 0 : message.request) === 'arcade spv update')) {
              _context8.n = 20;
              break;
            }
            tx = new Transaction(undefined, message.data);
            _this6.hasSeenTransaction(tx);
            txmsg = tx.returnMessage();
            if (!(txmsg.module === 'Arcade')) {
              _context8.n = 15;
              break;
            }
            if (!(txmsg.request === 'open' || txmsg.request === 'private')) {
              _context8.n = 9;
              break;
            }
            _context8.n = 9;
            return _this6.receiveOpenTransaction(tx);
          case 9:
            if (!(txmsg.request == 'join')) {
              _context8.n = 10;
              break;
            }
            _context8.n = 10;
            return _this6.receiveJoinTransaction(tx);
          case 10:
            if (!(txmsg.request == 'leave')) {
              _context8.n = 11;
              break;
            }
            _context8.n = 11;
            return _this6.receiveLeaveTransaction(tx);
          case 11:
            if (!(txmsg.request == 'cancel')) {
              _context8.n = 12;
              break;
            }
            _context8.n = 12;
            return _this6.receiveCancelTransaction(tx);
          case 12:
            if (!(txmsg.request === 'accept')) {
              _context8.n = 13;
              break;
            }
            _context8.n = 13;
            return _this6.receiveAcceptTransaction(tx);
          case 13:
            if (!(txmsg.request === 'arcade update peer status')) {
              _context8.n = 14;
              break;
            }
            _context8.n = 14;
            return _this6.receivePeerStatusUpdateTransaction(tx);
          case 14:
            _context8.n = 19;
            break;
          case 15:
            if (!(txmsg.request === 'stopgame')) {
              _context8.n = 16;
              break;
            }
            _context8.n = 16;
            return _this6.receiveCloseTransaction(tx);
          case 16:
            if (!(txmsg.request === 'gameover')) {
              _context8.n = 17;
              break;
            }
            _context8.n = 17;
            return _this6.receiveGameOverTransaction(tx);
          case 17:
            if (!_this6.app.BROWSER) {
              _context8.n = 18;
              break;
            }
            if (!(txmsg.request === 'game')) {
              _context8.n = 18;
              break;
            }
            _context8.n = 18;
            return _this6.receiveGameStepTransaction(tx);
          case 18:
            if (txmsg.request === 'JOIN' || txmsg.request === 'LEAVE' || txmsg.request === 'CANCEL') {
              _this6.receiveGametableMeta(tx);
            }
          case 19:
            //
            // only servers notify lite-clients
            //
            if (app.BROWSER == 0 && app.SPVMODE == 0) {
              _this6.notifyPeers(tx);
            }
            return _context8.a(2, 1);
          case 20:
            return _context8.a(2, ModTemplate.prototype.handlePeerTransaction.call(_this6, app, newtx, peer, mycallback));
        }
      }, _callee7);
    }))();
  },
  onConnectionUnstable: function onConnectionUnstable(app, publicKey) {
    var _this7 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var newtx, id, record;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            if (!(_this7.app.BROWSER == 1)) {
              _context9.n = 1;
              break;
            }
            return _context9.a(2);
          case 1:
            _context9.n = 2;
            return _this7.app.wallet.createUnsignedTransactionWithDefaultFee();
          case 2:
            newtx = _context9.v;
            newtx.msg = {
              module: 'Arcade',
              request: 'arcade update peer status',
              data: {
                publickey: publicKey,
                status: 'offline'
              }
            };
            _context9.n = 3;
            return newtx.sign();
          case 3:
            _this7.notifyPeers(newtx);
            for (id in _this7.invites) {
              record = _this7.invites[id];
              if (record.tx.from[0].publicKey === publicKey) {
                record.is_sender_reachable = false;
              }
            }
          case 4:
            return _context9.a(2);
        }
      }, _callee8);
    }))();
  },
  //
  // send TX to our SPV peers
  notifyPeers: function notifyPeers(tx) {
    var _this8 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      var peers, _iterator2, _step2, peer, message;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            if (!(_this8.app.BROWSER == 1)) {
              _context0.n = 1;
              break;
            }
            return _context0.a(2);
          case 1:
            _context0.n = 2;
            return _this8.app.network.getPeers();
          case 2:
            peers = _context0.v;
            _iterator2 = _createForOfIteratorHelper(peers);
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                peer = _step2.value;
                if (peer.synctype == 'lite' && (peer === null || peer === void 0 ? void 0 : peer.status) !== 'disconnected') {
                  //
                  // fwd tx to peer
                  //
                  message = {};
                  message.request = 'arcade spv update';
                  message.data = tx.toJson();
                  _this8.app.network.sendRequestAsTransaction(message.request, message.data, null, peer.publicKey);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          case 3:
            return _context0.a(2);
        }
      }, _callee9);
    }))();
  },
  createOpenTransaction: function createOpenTransaction(gamedata) {
    var _this9 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
      var sendto, moduletype, ts, name, options, players_needed, invitation_type, accept_sig, newtx, _t5, _t6;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.n) {
          case 0:
            sendto = _this9.publicKey;
            moduletype = 'Arcade';
            ts = gamedata.ts, name = gamedata.name, options = gamedata.options, players_needed = gamedata.players_needed, invitation_type = gamedata.invitation_type;
            console.log('GAMEDATA: ' + JSON.stringify(gamedata));
            _t5 = _this9.app.crypto;
            _t6 = "invite_game_".concat(ts);
            _context1.n = 1;
            return _this9.app.wallet.getPrivateKey();
          case 1:
            _context1.n = 2;
            return _t5.signMessage.call(_t5, _t6, _context1.v);
          case 2:
            accept_sig = _context1.v;
            _context1.n = 3;
            return _this9.app.wallet.createUnsignedTransactionWithDefaultFee();
          case 3:
            newtx = _context1.v;
            newtx.addTo(_this9.publicKey);
            if (options !== null && options !== void 0 && options.desired_opponent_publickey) {
              newtx.addTo(options.desired_opponent_publickey);
            }
            newtx.msg = {
              timestamp: ts,
              module: moduletype,
              request: invitation_type,
              game: name,
              options: options,
              players_needed: parseInt(players_needed),
              players: [_this9.publicKey],
              players_sigs: [accept_sig],
              originator: _this9.publicKey
            };
            _context1.n = 4;
            return newtx.sign();
          case 4:
            return _context1.a(2, newtx);
        }
      }, _callee0);
    }))();
  },
  receiveOpenTransaction: function receiveOpenTransaction(tx) {
    var _arguments3 = arguments,
      _this0 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
      var _txmsg$options;
      var blk, txmsg;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.n) {
          case 0:
            blk = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : null;
            txmsg = tx.returnMessage(); // add to games list == open or private
            _this0.addInviteRecord(tx);
            _this0.renderInvites();
            if (!tx.isFrom(_this0.publicKey)) {
              _context10.n = 1;
              break;
            }
            clearTimeout(_this0.game_timeout);
            if (_this0.app.browser.isMobileBrowser(navigator.userAgent) && !_this0.browser_active) {
              siteMessage('Game invite created', 1000);
            } else {
              if (txmsg.request == 'private') {
                _this0.showShareLink(tx.signature);
              }
            }
            return _context10.a(2);
          case 1:
            if ((txmsg === null || txmsg === void 0 || (_txmsg$options = txmsg.options) === null || _txmsg$options === void 0 ? void 0 : _txmsg$options.desired_opponent_publickey) == _this0.publicKey) {
              siteMessage("You were invited to play ".concat(txmsg.game), 5000);
            }
          case 2:
            return _context10.a(2);
        }
      }, _callee1);
    }))();
  },
  createCancelTransaction: function createCancelTransaction(orig_tx) {
    var _this1 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
      var newtx, _iterator3, _step3, player, msg;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            _context11.n = 1;
            return _this1.app.wallet.createUnsignedTransactionWithDefaultFee();
          case 1:
            newtx = _context11.v;
            _iterator3 = _createForOfIteratorHelper(orig_tx.msg.players);
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                player = _step3.value;
                newtx.addTo(player);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            newtx.addTo(_this1.publicKey);
            msg = {
              request: 'cancel',
              module: 'Arcade',
              game_id: orig_tx.signature
            };
            newtx.msg = msg;
            _context11.n = 2;
            return newtx.sign();
          case 2:
            return _context11.a(2, newtx);
        }
      }, _callee10);
    }))();
  },
  receiveCancelTransaction: function receiveCancelTransaction(tx) {
    var _this10 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
      var _game$tx, _game$tx$msg$options;
      var txmsg, game, p_index;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.n) {
          case 0:
            txmsg = tx.returnMessage();
            game = _this10.returnGame(txmsg.game_id);
            if (!(!game || !((_game$tx = game.tx) !== null && _game$tx !== void 0 && _game$tx.msg))) {
              _context12.n = 1;
              break;
            }
            return _context12.a(2);
          case 1:
            if (game.tx.msg.players.includes(tx.from[0].publicKey)) {
              if (tx.from[0].publicKey == game.tx.msg.originator) {
                _this10.changeGameStatus(txmsg.game_id, 'closed');
              } else {
                p_index = game.tx.msg.players.indexOf(tx.from[0].publicKey);
                game.tx.msg.players.splice(p_index, 1);
                //Make sure player_sigs array exists and add invite_sig
                if (game.tx.msg.players_sigs && game.tx.msg.players_sigs.length > p_index) {
                  game.tx.msg.players_sigs.splice(p_index, 1);
                }
              }
            } else if ((_game$tx$msg$options = game.tx.msg.options) !== null && _game$tx$msg$options !== void 0 && _game$tx$msg$options.desired_opponent_publickey && tx.isFrom(game.tx.msg.options.desired_opponent_publickey)) {
              if (_this10.publicKey == game.tx.msg.originator) {
                siteMessage('Your game invite was declined', 5000);
              }
              _this10.changeGameStatus(txmsg.game_id, 'closed');
            }
            _this10.app.connection.emit('arcade-close-game', txmsg.game_id);
            _this10.renderInvites();
          case 2:
            return _context12.a(2);
        }
      }, _callee11);
    }))();
  },
  sendCancelTransaction: function sendCancelTransaction(game_id) {
    var _this11 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
      var _game$tx2;
      var game, close_tx;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.n) {
          case 0:
            game = _this11.returnGame(game_id);
            if (!(!game || !((_game$tx2 = game.tx) !== null && _game$tx2 !== void 0 && _game$tx2.msg))) {
              _context13.n = 1;
              break;
            }
            return _context13.a(2);
          case 1:
            _context13.n = 2;
            return _this11.createCancelTransaction(game.tx);
          case 2:
            close_tx = _context13.v;
            _this11.app.network.propagateTransaction(close_tx);
            _this11.app.connection.emit('relay-send-message', {
              recipient: game.tx.msg.players,
              request: 'arcade spv update',
              data: close_tx.toJson()
            });
            _this11.app.connection.emit('relay-send-message', {
              recipient: 'PEERS',
              request: 'arcade spv update',
              data: close_tx.toJson()
            });
          case 3:
            return _context13.a(2);
        }
      }, _callee12);
    }))();
  },
  changeGameStatus: function changeGameStatus(game_id, newStatus) {
    var game = this.returnGame(game_id);

    //Move game to different list
    if (game) {
      if (this.sudo) {
        console.debug("ARCADE: Change game (".concat(game_id.substring(0, 10), "...) status from ").concat(game.tx.msg.request, " to ").concat(newStatus));
      }
      if (!(this !== null && this !== void 0 && this.sudo)) {
        var _game$tx3, _game$tx4;
        if (((_game$tx3 = game.tx) === null || _game$tx3 === void 0 || (_game$tx3 = _game$tx3.msg) === null || _game$tx3 === void 0 ? void 0 : _game$tx3.request) == 'over' || ((_game$tx4 = game.tx) === null || _game$tx4 === void 0 || (_game$tx4 = _game$tx4.msg) === null || _game$tx4 === void 0 ? void 0 : _game$tx4.request) == 'closed') {
          return;
        }
      }
      this.removeInviteRecord(game_id);
      this.addInviteRecord(game.tx, newStatus);
    }
    this.renderInvites();
  },
  receiveGameOverTransaction: function receiveGameOverTransaction(tx) {
    var _this12 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
      var _game$tx5;
      var txmsg, game, winner;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.n) {
          case 0:
            txmsg = tx.returnMessage();
            game = _this12.returnGame(txmsg.game_id); //In case we arrive at gameover without close game
            _this12.app.connection.emit('arcade-close-game', txmsg.game_id);
            _this12.changeGameStatus(txmsg.game_id, 'over');
            winner = txmsg.winner || null;
            if (game !== null && game !== void 0 && (_game$tx5 = game.tx) !== null && _game$tx5 !== void 0 && _game$tx5.msg) {
              //Store the results locally
              game.tx.msg.winner = winner;
              game.tx.msg.method = txmsg.reason;
              game.tx.msg.time_finished = txmsg.timestamp;
            } else {
              console.warn("Game not found, arcade can't process gameover tx");
            }
          case 1:
            return _context14.a(2);
        }
      }, _callee13);
    }))();
  },
  receiveCloseTransaction: function receiveCloseTransaction(tx) {
    var _this13 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
      var txmsg;
      return _regenerator().w(function (_context15) {
        while (1) switch (_context15.n) {
          case 0:
            txmsg = tx.returnMessage(); // Mark game as closed, unless it is a player leaving an open table...
            if (txmsg.reason !== 'withdraw') {
              _this13.app.connection.emit('arcade-close-game', txmsg.game_id);
              _this13.changeGameStatus(txmsg.game_id, 'closed');
            }
          case 1:
            return _context15.a(2);
        }
      }, _callee14);
    }))();
  },
  receiveGameStepTransaction: function receiveGameStepTransaction(tx) {
    var _this14 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
      var _game$tx6;
      var txmsg, game;
      return _regenerator().w(function (_context16) {
        while (1) switch (_context16.n) {
          case 0:
            txmsg = tx.returnMessage();
            game = _this14.returnGame(txmsg.game_id);
            if (game !== null && game !== void 0 && (_game$tx6 = game.tx) !== null && _game$tx6 !== void 0 && _game$tx6.msg) {
              game.tx.msg.step = txmsg.step.game;
              game.tx.msg.timestamp = txmsg.step.timestamp;
            }
          case 1:
            return _context16.a(2);
        }
      }, _callee15);
    }))();
  },
  ///////////////
  // JOIN GAME //
  ///////////////
  //
  // join is the act of adding yourself to a game that does not have enough
  // players. technically, you're providing a signature that -- when returned
  // as part of a valid game, will trigger your browser to start initializing
  // the game.
  createJoinTransaction: function createJoinTransaction(orig_tx) {
    var _arguments4 = arguments,
      _this15 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
      var option_update, txmsg, newtx, _iterator4, _step4, player, _t7, _t8;
      return _regenerator().w(function (_context17) {
        while (1) switch (_context17.n) {
          case 0:
            option_update = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : null;
            if (!(!orig_tx || !orig_tx.signature)) {
              _context17.n = 1;
              break;
            }
            console.error('ARCADE: Invalid Game Invite TX, cannot Join');
            return _context17.a(2);
          case 1:
            txmsg = orig_tx.returnMessage();
            _context17.n = 2;
            return _this15.app.wallet.createUnsignedTransactionWithDefaultFee();
          case 2:
            newtx = _context17.v;
            _iterator4 = _createForOfIteratorHelper(txmsg.players);
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                player = _step4.value;
                newtx.addTo(player);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
            newtx.addTo(_this15.publicKey);
            newtx.msg = JSON.parse(JSON.stringify(txmsg));
            newtx.msg.module = 'Arcade';
            newtx.msg.request = 'join';
            newtx.msg.game_id = orig_tx.signature;
            if (option_update) {
              newtx.msg.options = orig_tx.msg.options[option_update];
              newtx.msg.update_options = option_update;
            }
            _t7 = _this15.app.crypto;
            _t8 = 'invite_game_' + orig_tx.msg.timestamp;
            _context17.n = 3;
            return _this15.app.wallet.getPrivateKey();
          case 3:
            _context17.n = 4;
            return _t7.signMessage.call(_t7, _t8, _context17.v);
          case 4:
            newtx.msg.invite_sig = _context17.v;
            _context17.n = 5;
            return newtx.sign();
          case 5:
            return _context17.a(2, newtx);
        }
      }, _callee16);
    }))();
  },
  sendJoinTransaction: function sendJoinTransaction(invite) {
    var _arguments5 = arguments,
      _this16 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
      var update_options, newtx;
      return _regenerator().w(function (_context18) {
        while (1) switch (_context18.n) {
          case 0:
            update_options = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : '';
            _context18.n = 1;
            return _this16.createJoinTransaction(invite.tx, update_options);
          case 1:
            newtx = _context18.v;
            //
            // send it on-chain and off-chain
            //
            _this16.app.network.propagateTransaction(newtx);
            _this16.app.connection.emit('relay-send-message', {
              recipient: 'PEERS',
              request: 'arcade spv update',
              data: newtx.toJson()
            });
            _this16.renderInvites();
          case 2:
            return _context18.a(2);
        }
      }, _callee17);
    }))();
  },
  receiveJoinTransaction: function receiveJoinTransaction(tx) {
    var _this17 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
      var txmsg, game, _game$tx$msg$options2, newtx;
      return _regenerator().w(function (_context19) {
        while (1) switch (_context19.n) {
          case 0:
            if (!(!tx || !tx.signature)) {
              _context19.n = 1;
              break;
            }
            return _context19.a(2);
          case 1:
            txmsg = tx.returnMessage(); //Transaction must be signed
            if (txmsg.invite_sig) {
              _context19.n = 2;
              break;
            }
            return _context19.a(2);
          case 2:
            //
            // game is the record (tx + state); game.tx is the original invite creation TX.
            //
            game = _this17.returnGame(txmsg.game_id); //
            // If we don't find it, or we have already marked the game as active, stop processing
            //
            if (game) {
              _context19.n = 3;
              break;
            }
            return _context19.a(2);
          case 3:
            if (!game.state) {
              _context19.n = 4;
              break;
            }
            return _context19.a(2);
          case 4:
            if (game.tx.msg.players.includes(tx.from[0].publicKey)) {
              _context19.n = 6;
              break;
            }
            if (!_this17.isAvailableGame(game.tx)) {
              _context19.n = 5;
              break;
            }
            if (txmsg.update_options) {
              console.info("ARCADE: Join TX updates the invite options -- ".concat(txmsg.update_options, "!"), game.tx.msg.options, txmsg.options);
              Object.assign(game.tx.msg.options[txmsg.update_options], txmsg.options);
            }

            //
            // add player to game
            //
            game.tx.msg.players.push(tx.from[0].publicKey);
            game.tx.msg.players_sigs.push(txmsg.invite_sig);

            // Move player from tentatitive to full on...
            _this17.clearTentative(txmsg.game_id, tx.from[0].publicKey);
            _this17.removeInviteRecord(txmsg.game_id);
            _this17.addInviteRecord(game.tx);
            _this17.renderInvites();
            _context19.n = 6;
            break;
          case 5:
            if (!tx.isFrom(_this17.publicKey)) {
              _context19.n = 6;
              break;
            }
            salert('Game not available right now...');
            return _context19.a(2);
          case 6:
            if (!(game.tx.msg.request == 'active' || game.tx.msg.request == 'over')) {
              _context19.n = 7;
              break;
            }
            return _context19.a(2);
          case 7:
            if (!game.state) {
              _context19.n = 8;
              break;
            }
            return _context19.a(2);
          case 8:
            if (!(game.tx.msg.players.length >= game.tx.msg.players_needed && game.tx.msg.request !== 'accepted' && game.tx.msg.request !== 'active')) {
              _context19.n = 11;
              break;
            }
            //
            // Temporarily change it so we don't process additional joins
            //
            game.tx.msg.request = 'accepted';

            //
            // First player (originator) sends the accept message
            //
            if (!(game.tx.msg.originator == _this17.publicKey || tx.isFrom(_this17.publicKey) && (_game$tx$msg$options2 = game.tx.msg.options) !== null && _game$tx$msg$options2 !== void 0 && _game$tx$msg$options2.async_dealing)) {
              _context19.n = 11;
              break;
            }
            _context19.n = 9;
            return _this17.createAcceptTransaction(game.tx);
          case 9:
            newtx = _context19.v;
            if (newtx) {
              _context19.n = 10;
              break;
            }
            console.warn('ARCADE: createAcceptTransaction returned nothing; skipping propagate and lounge overlay');
            return _context19.a(2);
          case 10:
            _this17.app.network.propagateTransaction(newtx);
            _this17.app.connection.emit('relay-send-message', {
              recipient: 'PEERS',
              request: 'arcade spv update',
              data: newtx.toJson()
            });

            //Start Spinner now instead of waiting for accept transaction to arrive
            _this17.render('lounge_overlay', {
              game_id: txmsg.game_id
            });
          case 11:
            return _context19.a(2);
        }
      }, _callee18);
    }))();
  },
  sendLeaveTransaction: function sendLeaveTransaction(invite_tx, data) {
    var _this18 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
      var txmsg, newtx, _iterator5, _step5, player;
      return _regenerator().w(function (_context20) {
        while (1) switch (_context20.n) {
          case 0:
            txmsg = invite_tx.returnMessage();
            _context20.n = 1;
            return _this18.app.wallet.createUnsignedTransactionWithDefaultFee();
          case 1:
            newtx = _context20.v;
            _iterator5 = _createForOfIteratorHelper(txmsg.players);
            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                player = _step5.value;
                newtx.addTo(player);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
            newtx.addTo(_this18.publicKey);
            newtx.msg = JSON.parse(JSON.stringify(txmsg));
            newtx.msg.module = 'Arcade';
            newtx.msg.request = 'leave';
            newtx.msg.game_id = invite_tx.signature;
            newtx.msg.data = data;
            _context20.n = 2;
            return newtx.sign();
          case 2:
            _this18.app.network.propagateTransaction(newtx);
            _this18.app.connection.emit('relay-send-message', {
              recipient: 'PEERS',
              request: 'arcade spv update',
              data: newtx.toJson()
            });
            _this18.renderInvites();
          case 3:
            return _context20.a(2);
        }
      }, _callee19);
    }))();
  },
  receiveLeaveTransaction: function receiveLeaveTransaction(tx) {
    var _this19 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
      var txmsg, game, _game$tx$msg$options3, index;
      return _regenerator().w(function (_context21) {
        while (1) switch (_context21.n) {
          case 0:
            if (!(!tx || !tx.signature)) {
              _context21.n = 1;
              break;
            }
            return _context21.a(2);
          case 1:
            txmsg = tx.returnMessage(); //
            // game is the record (tx + status + state) for the invite.
            //
            game = _this19.returnGame(txmsg.game_id); //
            // If we don't find it, or we have already marked the game as active, stop processing
            //
            if (game) {
              _context21.n = 2;
              break;
            }
            return _context21.a(2);
          case 2:
            //
            // Don't remove the same player twice!
            //
            if (game.tx.msg.players.includes(tx.from[0].publicKey)) {
              index = game.tx.msg.players.indexOf(tx.from[0].publicKey);
              game.tx.msg.players.splice(index, 1);
              game.tx.msg.players_sigs.splice(index, 1);
              if (!((_game$tx$msg$options3 = game.tx.msg.options) !== null && _game$tx$msg$options3 !== void 0 && _game$tx$msg$options3.eliminated)) {
                game.tx.msg.options.eliminated = {};
              }
              game.tx.msg.options.eliminated[tx.from[0].publicKey] = txmsg.data;
              _this19.clearTentative(txmsg.game_id, tx.from[0].publicKey);
              _this19.removeInviteRecord(txmsg.game_id);
              _this19.addInviteRecord(game.tx);
              _this19.renderInvites();
            }
          case 3:
            return _context21.a(2);
        }
      }, _callee20);
    }))();
  },
  /////////////////
  // ACCEPT GAME //
  /////////////////
  //
  // this transaction should be a valid game that has signatures from everyone
  // and is capable of initializing a game. if this TX is valid and has our
  // signature we will auto-accept it, kicking off the game.
  createAcceptTransaction: function createAcceptTransaction(orig_tx) {
    var _this20 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
      var txmsg, newtx, i;
      return _regenerator().w(function (_context22) {
        while (1) switch (_context22.n) {
          case 0:
            if (!(!orig_tx || !orig_tx.signature)) {
              _context22.n = 1;
              break;
            }
            console.error('ARCADE: Invalid Game Invite TX, cannot Accept');
            return _context22.a(2);
          case 1:
            // Use returnMessage() so we get the full message even if tx was deserialized (lazy .msg)
            txmsg = orig_tx.returnMessage();
            if (!(!txmsg || !txmsg.players || txmsg.players.length === 0)) {
              _context22.n = 2;
              break;
            }
            console.error('ARCADE: createAcceptTransaction -- invalid or empty message from orig_tx', orig_tx.signature);
            return _context22.a(2);
          case 2:
            // Provide originator if missing: open-invite creator is always the first player
            if (txmsg.originator == null || txmsg.originator === '') {
              txmsg.originator = txmsg.players[0];
            }
            _context22.n = 3;
            return _this20.app.wallet.createUnsignedTransactionWithDefaultFee();
          case 3:
            newtx = _context22.v;
            for (i = 0; i < txmsg.players.length; i++) {
              newtx.addTo(txmsg.players[i]);
            }
            newtx.msg = JSON.parse(JSON.stringify(txmsg));
            newtx.msg.module = 'Arcade';
            newtx.msg.game_id = orig_tx.signature;
            newtx.msg.request = 'accept';
            _context22.n = 4;
            return newtx.sign();
          case 4:
            return _context22.a(2, newtx);
        }
      }, _callee21);
    }))();
  },
  receiveAcceptTransaction: function receiveAcceptTransaction(tx) {
    var _this21 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
      var _txmsg$options2;
      var txmsg, gamemod, game, i, _this21$app, game_engine_id;
      return _regenerator().w(function (_context23) {
        while (1) switch (_context23.n) {
          case 0:
            if (tx) {
              _context23.n = 1;
              break;
            }
            console.error('ARCADE: Invalid Accept tx');
            return _context23.a(2);
          case 1:
            txmsg = tx.returnMessage();
            if (txmsg) {
              _context23.n = 2;
              break;
            }
            console.error('ARCADE: receiveAcceptTransaction -- tx.returnMessage() is null; cannot initialize', tx === null || tx === void 0 ? void 0 : tx.signature);
            return _context23.a(2);
          case 2:
            if (!(txmsg.originator == null || txmsg.originator === '')) {
              _context23.n = 3;
              break;
            }
            console.error('ARCADE: receiveAcceptTransaction -- originator missing in accept tx; refusing to pass to game engine', txmsg.game_id);
            return _context23.a(2);
          case 3:
            //
            // Must have game module installed
            // We call the game-initialization function directly on gamemod further down
            //
            gamemod = _this21.app.modules.returnModule(txmsg.game); // I guess this safety catch should be further up the processing chain, like we shouldn't even display an invite/join a game we don't have installed
            if (gamemod) {
              _context23.n = 4;
              break;
            }
            console.error('ARCADE Error Initializing! Game Module not Installed -- ' + txmsg.game);
            return _context23.a(2);
          case 4:
            game = _this21.returnGame(txmsg.game_id); // Must be an available invite
            if (!(!game || !_this21.isAvailableGame(game.tx, 'accepted') && !((_txmsg$options2 = txmsg.options) !== null && _txmsg$options2 !== void 0 && _txmsg$options2.async_dealing))) {
              _context23.n = 5;
              break;
            }
            return _context23.a(2);
          case 5:
            i = 0;
          case 6:
            if (!(i < ((_this21$app = _this21.app) === null || _this21$app === void 0 || (_this21$app = _this21$app.options) === null || _this21$app === void 0 || (_this21$app = _this21$app.games) === null || _this21$app === void 0 ? void 0 : _this21$app.length))) {
              _context23.n = 8;
              break;
            }
            if (!(_this21.app.options.games[i].id === txmsg.game_id)) {
              _context23.n = 7;
              break;
            }
            console.debug('ARCADE: [receiveAcceptTX] game already accepted and in my options');
            return _context23.a(2);
          case 7:
            i++;
            _context23.n = 6;
            break;
          case 8:
            if (!game.state) {
              _context23.n = 9;
              break;
            }
            return _context23.a(2);
          case 9:
            //
            // Mark the game as accept, i.e. active
            //
            _this21.changeGameStatus(txmsg.game_id, 'active');

            //
            // If I am a player in the game, let's start it initializing
            //
            if (!txmsg.players.includes(_this21.publicKey)) {
              _context23.n = 11;
              break;
            }
            if (!_this21.app.options.arcade[txmsg.game]) {
              _this21.app.options.arcade[txmsg.game] = 0;
            }
            _this21.app.options.arcade[txmsg.game]++;
            _this21.app.options.arcade.last_game = txmsg.game;
            if (_this21.browser_active) {
              _this21.render('lounge_overlay', {
                game_id: txmsg.game_id
              });
            } else if (_this21.app.BROWSER == 1 && txmsg.players.length > 1) {
              siteMessage(txmsg.game + ' initializing', 5000);
            }
            _context23.n = 10;
            return gamemod.initializeGameFromAcceptTransaction(tx);
          case 10:
            game_engine_id = _context23.v;
            if (!game_engine_id || game_engine_id !== txmsg.game_id) {
              salert('Something went wrong with the game initialization: ' + game_engine_id);
            }
          case 11:
            return _context23.a(2);
        }
      }, _callee22);
    }))();
  },
  receivePeerStatusUpdateTransaction: function receivePeerStatusUpdateTransaction(tx) {
    var _this22 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
      var _txmsg$data, _txmsg$data2;
      var txmsg, pk, status, id, record;
      return _regenerator().w(function (_context24) {
        while (1) switch (_context24.n) {
          case 0:
            txmsg = tx.returnMessage();
            pk = (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.publickey;
            status = (_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.status;
            if (!(!pk || !status)) {
              _context24.n = 1;
              break;
            }
            return _context24.a(2, 0);
          case 1:
            for (id in _this22.invites) {
              record = _this22.invites[id];
              if (record.tx.from[0].publicKey === pk) {
                record.is_sender_reachable = status === 'online';
              }
            }
            if (_this22.app.BROWSER) {
              _this22.renderInvites();
            }
            return _context24.a(2, 0);
        }
      }, _callee23);
    }))();
  },
  ///////////////////////////////
  // "LOAD"ING AND RUNNING GAMES //
  ///////////////////////////////
  //
  // single player game
  addInviteRecord: function addInviteRecord(tx) {
    var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!tx || !tx.msg || !tx.signature) {
      // console.error("ARCADE: [addGame] Invalid Game TX, won't add to list", tx);
      return false;
    }
    if (this.invites[tx.signature]) {
      return false;
    }
    if (list) {
      // status from caller
    } else {
      var _tx$msg;
      list = ((_tx$msg = tx.msg) === null || _tx$msg === void 0 ? void 0 : _tx$msg.request) || 'open';
    }
    if (list !== 'over' && !list.includes('close')) {
      if (this.isMyGame(tx)) {
        list = 'mine';
      } else {
        if (tx.msg.players_needed <= tx.msg.players.length) {
          list = 'active';
        }
      }
    }
    this.invites[tx.signature] = {
      tx: tx,
      status: list,
      updated_at: Date.now(),
      is_sender_reachable: true
    };
    return true;
  },
  removeInviteRecord: function removeInviteRecord(game_id) {
    delete this.invites[game_id];
  },
  returnGame: function returnGame(game_id) {
    var _this$app$options;
    var record = this.invites[game_id] || null;
    if (!record) return null;
    var engineState = ((_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.games) === null || _this$app$options === void 0 ? void 0 : _this$app$options.find(function (g) {
      return g.id === game_id;
    })) || null;
    return _objectSpread(_objectSpread({}, record), {}, {
      state: engineState
    });
  },
  //
  // tentative roster lives ON the invite tx message so it survives
  // serialization to clients that fetch the invite list cold (needed to gate
  // the "join" button on table capacity)
  returnTentative: function returnTentative(game_id) {
    var _record$tx;
    var record = this.invites[game_id];
    if (!(record !== null && record !== void 0 && (_record$tx = record.tx) !== null && _record$tx !== void 0 && _record$tx.msg)) {
      return {
        join: [],
        leave: []
      };
    }
    if (!record.tx.msg.tentative) {
      record.tx.msg.tentative = {
        join: [],
        leave: []
      };
    }
    return record.tx.msg.tentative;
  },
  //
  // record intent to join/leave an open table (from the game's JOIN/LEAVE
  // metas), so the lounge can show pending players before the roster is
  // finalized on-chain
  receiveGametableMeta: function receiveGametableMeta(tx) {
    var txmsg = tx.returnMessage();
    var game_id = txmsg.game_id;
    if (!game_id || !this.invites[game_id]) {
      return;
    }
    var t = this.returnTentative(game_id);
    var roster = this.invites[game_id].tx.msg.players || [];
    if (txmsg.request === 'JOIN') {
      var _txmsg$data3;
      // the joiner is data.pkey (JOIN metas are rebroadcast by each signer)
      var pkey = (_txmsg$data3 = txmsg.data) === null || _txmsg$data3 === void 0 ? void 0 : _txmsg$data3.pkey;
      if (pkey && !t.join.includes(pkey) && !roster.includes(pkey)) {
        t.join.push(pkey);
        this.renderInvites();
      }
    } else if (txmsg.request === 'LEAVE') {
      var _pkey = txmsg.my_key;
      if (_pkey && !t.leave.includes(_pkey)) {
        t.leave.push(_pkey);
        this.renderInvites();
      }
    } else if (txmsg.request === 'CANCEL') {
      var _pkey2 = txmsg.my_key;
      var before = t.join.length + t.leave.length;
      t.join = t.join.filter(function (k) {
        return k !== _pkey2;
      });
      t.leave = t.leave.filter(function (k) {
        return k !== _pkey2;
      });
      if (t.join.length + t.leave.length !== before) {
        this.renderInvites();
      }
    }
  },
  clearTentative: function clearTentative(game_id, pkey) {
    var _record$tx2;
    var record = this.invites[game_id];
    var t = record === null || record === void 0 || (_record$tx2 = record.tx) === null || _record$tx2 === void 0 || (_record$tx2 = _record$tx2.msg) === null || _record$tx2 === void 0 ? void 0 : _record$tx2.tentative;
    if (!t) {
      return;
    }
    t.join = t.join.filter(function (k) {
      return k !== pkey;
    });
    t.leave = t.leave.filter(function (k) {
      return k !== pkey;
    });
  },
  returnGameTransaction: function returnGameTransaction(game_id) {
    var record = this.returnGame(game_id);
    if (record.tx) {
      return record.tx;
    }
    return null;
  },
  returnGamesWithFilter: function returnGamesWithFilter(filterObject) {
    return Object.values(this.invites).filter(function (record) {
      for (var key in filterObject) {
        if (record[key] !== filterObject[key]) return false;
      }
      return true;
    });
  },
  purge: function purge() {
    var INVITE_CUTOFF = 2000000; // 30 minutes
    var GAME_CUTOFF = 600000000;
    var now = new Date().getTime();
    var walletModified = false;

    // --- Expire open/mine to closed (previous setInterval logic) ---
    for (var _i = 0, _Object$keys = Object.keys(this.invites); _i < _Object$keys.length; _i++) {
      var id = _Object$keys[_i];
      var record = this.invites[id];
      var g = record.tx;
      if ((record.status === 'mine' || record.status === 'open') && g.timestamp < now - INVITE_CUTOFF) {
        this.removeInviteRecord(g.signature);
        this.addInviteRecord(g, 'closed');
      }
    }

    // --- Purge this.invites by age ---
    for (var _i2 = 0, _Object$keys2 = Object.keys(this.invites); _i2 < _Object$keys2.length; _i2++) {
      var _id = _Object$keys2[_i2];
      var _record = this.invites[_id];
      var cutoff = now - INVITE_CUTOFF;
      if (_record.status === 'active' || _record.status === 'over' || _record.status === 'mine') {
        cutoff = now - GAME_CUTOFF;
      }
      if (_record.tx.timestamp <= cutoff) {
        delete this.invites[_id];
      }
    }
    if (this.app.BROWSER) {
      // Second pass: expire my invites that are not available
      var _cutoff = now - INVITE_CUTOFF;
      for (var _i3 = 0, _Object$keys3 = Object.keys(this.invites); _i3 < _Object$keys3.length; _i3++) {
        var _id2 = _Object$keys3[_i3];
        var _record2 = this.invites[_id2];
        if (_record2.status !== 'mine') continue;
        if (!this.isAvailableGame(_record2.tx) && _record2.tx.timestamp < _cutoff) {
          siteMessage('Game invite timed out...', 4000);
          delete this.invites[_id2];
        }
      }
    }

    // --- Purge malformed wallet games (from purgeBadGamesFromWallet) ---
    if (this.app.options.games) {
      for (var i = this.app.options.games.length - 1; i >= 0; i--) {
        if (this.app.options.games[i].module === '' && this.app.options.games[i].id.length < 25) {
          this.app.options.games.splice(i, 1);
          walletModified = true;
        } else if (this.app.options.games[i].players_set == 0) {
          //This will be games created but not fully initialized for whatever reason
          this.app.options.games.splice(i, 1);
          walletModified = true;
        }
      }
    }

    // --- Purge completed/old wallet games (from purgeOldGamesFromWallet) ---
    if (this.app.options.games) {
      for (var _i4 = this.app.options.games.length - 1; _i4 >= 0; _i4--) {
        var _g = this.app.options.games[_i4];
        if (_g.over >= 1) {
          if (_g.timestamp < now - 240000) {
            // after 1 hour
            this.app.options.games.splice(_i4, 1);
            walletModified = true;
          }
        }
      }
    }
    if (walletModified) {
      this.app.storage.saveOptions();
      this.renderInvites();
    }
  },
  saveOptions: function saveOptions() {
    if (!this.app.BROWSER) {
      return;
    }
    if (!this.app.options.arcade) {
      this.app.options.arcade = {};
    }
    this.app.options.arcade['show-splash'] = this.show_splash;
    this.app.storage.saveOptions();
  },
  removeGameFromWallet: function removeGameFromWallet(game_id) {
    this.removeInviteRecord(game_id);
    if (this.app.options.games) {
      for (var i = 0; i < this.app.options.games.length; i++) {
        if (this.app.options.games[i].id === game_id) {
          this.app.options.games.splice(i, 1);
          break;
        }
      }
    }
    this.app.storage.saveOptions();
    this.renderInvites();
  },
  isAvailableGame: function isAvailableGame(game_tx) {
    var additional_status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (game_tx.msg.request == 'open' || game_tx.msg.request == 'private') {
      return true;
    }
    if (game_tx.msg.request == 'active' && game_tx.msg.options['open-table']) {
      return true;
    }
    if (additional_status && additional_status === game_tx.msg.request) {
      return true;
    }
    return false;
  },
  //
  // Determines whether the user is in any way associated with the game
  // Either they sent the invite, they have clicked join, or someone specifically invited them by key
  isMyGame: function isMyGame(tx) {
    for (var i = 0; i < tx.to.length; i++) {
      if (tx.to[i].publicKey == this.publicKey) {
        return true;
      }
    }
    for (var _i5 = 0; _i5 < tx.msg.players.length; _i5++) {
      if (tx.msg.players[_i5] == this.publicKey) {
        return true;
      }
    }
    if (tx.msg.options) {
      if (tx.msg.options.desired_opponent_publickey) {
        if (tx.msg.options.desired_opponent_publickey == this.publicKey) {
          return true;
        }
      }
    }
    return false;
  },
  returnOpenInvites: function returnOpenInvites() {
    var _this23 = this;
    return Object.values(this.invites).filter(function (r) {
      return r.status === 'mine' && _this23.isAvailableGame(r.tx) && _this23.publicKey == r.tx.msg.originator;
    }).map(function (r) {
      return r.tx.signature;
    });
  },
  shouldAffixCallbackToModule: function shouldAffixCallbackToModule(modname) {
    if (modname == 'Arcade') {
      return 1;
    }
    for (var i = 0; i < this.affix_callbacks_to.length; i++) {
      if (this.affix_callbacks_to[i] == modname) {
        return 1;
      }
    }
    return 0;
  },
  isSlug: function isSlug(slug) {
    if (slug == this.returnSlug()) {
      return true;
    }
    return false;
  },
  _handleGameReadyNotification: function _handleGameReadyNotification(game_details) {
    if (!(game_details !== null && game_details !== void 0 && game_details.id)) return;
    var game_id = game_details.id;
    this._closeReadyPopup();
    this._notifyGameReady(game_details);
    if (this._loungeOverlayOpenForGame(game_id)) {
      if (!this.lounge_overlay.showGameReadyState()) {
        this.render('lounge_overlay', {
          game_id: game_id
        });
      }
      return;
    }
    if (this.browser_active) {
      this.render('lounge_overlay', {
        game_id: game_id
      });
      return;
    }
    this._showReadyPopup(game_details);
  },
  _loungeOverlayOpenForGame: function _loungeOverlayOpenForGame(game_id) {
    if (!game_id || !this.lounge_overlay) return false;
    if (this.lounge_overlay.invite != null) return false;
    if (this.lounge_overlay.game_id !== game_id) return false;
    var ov = this.lounge_overlay.overlay;
    if (!(ov !== null && ov !== void 0 && ov.visible)) return false;
    var el = document.getElementById("saito-overlay".concat(ov.ordinal));
    return !!(el && el.style.display !== 'none' && el.querySelector('.arcade-lounge'));
  },
  _closeReadyPopup: function _closeReadyPopup() {
    var _this$ready_popup_ove;
    if ((_this$ready_popup_ove = this.ready_popup_overlay) !== null && _this$ready_popup_ove !== void 0 && _this$ready_popup_ove.visible) {
      this.ready_popup_overlay.close();
    }
  },
  _notifyGameReady: function _notifyGameReady(game_details) {
    if (!this.app.BROWSER || !this.main) return;
    var game_mod = this.app.modules.returnModuleBySlug(game_details === null || game_details === void 0 ? void 0 : game_details.slug);
    if (game_mod && !(game_mod.maxPlayers === 1 || this.app.browser.isMobileBrowser())) {
      this.app.browser.createTabNotification('Game ready!', (game_details === null || game_details === void 0 ? void 0 : game_details.name) || '');
      //siteMessage(`${game_details?.name || 'Game'} ready to play!`);
      try {
        var chime = new Audio('/saito/sound/Jinja.mp3');
        chime.play();
      } catch (e) {}
    }
  },
  _showReadyPopup: function _showReadyPopup(game_details) {
    var _game_mod$respondTo,
      _this24 = this;
    if (!this.app.BROWSER) return;
    if (!this.ready_popup_overlay) {
      this.ready_popup_overlay = new SaitoOverlay(this.app, this, true, true, false);
      this.ready_popup_overlay["class"] = 'saito-overlay arcade-ready-overlay';
      this.ready_popup_overlay.clickBackdropToClose = false;
    }
    var slug = (game_details === null || game_details === void 0 ? void 0 : game_details.slug) || 'arcade';
    var name = (game_details === null || game_details === void 0 ? void 0 : game_details.name) || 'Game';
    var game_mod = this.app.modules.returnModuleBySlug(slug);
    var image = (game_mod === null || game_mod === void 0 || (_game_mod$respondTo = game_mod.respondTo) === null || _game_mod$respondTo === void 0 || (_game_mod$respondTo = _game_mod$respondTo.call(game_mod, 'arcade-games')) === null || _game_mod$respondTo === void 0 ? void 0 : _game_mod$respondTo.image) || '';
    var headerImageStyle = image ? " style=\"background-image: url('".concat(image, "')\"") : '';
    var html = "\n            <div class=\"arcade-lounge arcade-lounge--ready-popup\">\n              <div class=\"arcade-lounge-header\">\n                <div class=\"arcade-lounge-header-image\"".concat(headerImageStyle, "></div>\n                <div class=\"arcade-lounge-header-title\">").concat(name, "</div>\n                <div class=\"arcade-lounge-header-desc\">Game Ready</div>\n              </div>\n              <div class=\"arcade-lounge-body\">\n                <p class=\"arcade-lounge-message\">Your table is set. Start when you are ready.</p>\n              </div>\n              <button type=\"button\" class=\"fat saito-button-primary arcade-ready-popup-start\" data-slug=\"").concat(slug, "\">Start Game</button>\n            </div>");
    this.ready_popup_overlay.show(html);
    var startBtn = document.querySelector('.arcade-ready-popup-start');
    if (startBtn) {
      startBtn.onclick = function () {
        _this24.ready_popup_overlay.close();
        navigateWindow("/".concat(slug), 200);
      };
    }
  },
  showShareLink: function showShareLink(game_sig) {
    var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var data = {};
    var accepted_game_tx = null;
    var accepted_game_msg = null;

    //Add more information about the game
    var game = this.returnGame(game_sig);
    if (game) {
      accepted_game_tx = game.tx;
    }
    if (accepted_game_tx) {
      var _game_mod$returnSlug, _game_mod$returnSlug2, _accepted_game_msg;
      accepted_game_msg = accepted_game_tx.msg;
      var game_mod = this.app.modules.returnModule(accepted_game_msg.game) || this.app.modules.returnModuleBySlug(accepted_game_msg.game);
      data.game = (_game_mod$returnSlug = game_mod === null || game_mod === void 0 || (_game_mod$returnSlug2 = game_mod.returnSlug) === null || _game_mod$returnSlug2 === void 0 ? void 0 : _game_mod$returnSlug2.call(game_mod)) !== null && _game_mod$returnSlug !== void 0 ? _game_mod$returnSlug : accepted_game_msg.game;
      data.game_id = game_sig;
      data.path = '/arcade/';
      data.invite = 1;
      if ((_accepted_game_msg = accepted_game_msg) !== null && _accepted_game_msg !== void 0 && (_accepted_game_msg = _accepted_game_msg.options) !== null && _accepted_game_msg !== void 0 && _accepted_game_msg.crypto) {
        data.crypto = accepted_game_msg.options.crypto;
      }

      // This is not a meaningful safety catch... the sharelink button is only available for available games...
      if (accepted_game_msg.players_needed > 1) {
        var game_invitation_link = new GameInvitationLink(this.app, this, data);
        game_invitation_link.render(show);
      } else {
        console.error('no players needed');
      }
    } else {
      console.error('Game not available');
    }
  },
  makeGameInvite: function makeGameInvite(options) {
    var _arguments6 = arguments,
      _this25 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
      var gameType, invite_obj, game, game_mod, players_needed, gamedata, opentx, newtx, open_invites, c, _iterator6, _step6, game_id, _newtx;
      return _regenerator().w(function (_context25) {
        while (1) switch (_context25.n) {
          case 0:
            gameType = _arguments6.length > 1 && _arguments6[1] !== undefined ? _arguments6[1] : 'open';
            invite_obj = _arguments6.length > 2 && _arguments6[2] !== undefined ? _arguments6[2] : {};
            game = options.game;
            game_mod = _this25.app.modules.returnModule(game);
            players_needed = options['game-wizard-players-select']; //
            // add league_id to options if this is a league game
            //
            if (invite_obj.league) {
              //The important piece of information
              options.league_id = invite_obj.league.id;
              //For convenience sake when making the join overlay
              options.league_name = invite_obj.league.name;
            }
            if (invite_obj.publicKey) {
              options.desired_opponent_publickey = invite_obj.publicKey;
              gameType = 'direct';
            }
            if (invite_obj.gameobj) {
              options.gameobj = invite_obj.gameobj;
              gameType = 'import';
            }
            if (players_needed) {
              _context25.n = 1;
              break;
            }
            console.error('ARCADE: [makeGameInvite] error, missing players_needed', options);
            return _context25.a(2);
          case 1:
            gamedata = {
              ts: new Date().getTime(),
              name: game,
              slug: game_mod.returnSlug(),
              options: options,
              players_needed: players_needed,
              invitation_type: gameType
            }; // Poker Validation
            if (!options['open-table']) {
              _context25.n = 3;
              break;
            }
            if (!(options.stake && _typeof(options.stake) === 'object')) {
              _context25.n = 3;
              break;
            }
            _context25.n = 2;
            return salert('Uneven staking is not allowed in cash games');
          case 2:
            options.stake = options.stake[_this25.publicKey].toString();
          case 3:
            if (!(parseInt(players_needed) === 1 || gameType === 'single' || game_mod.maxPlayers === 1)) {
              _context25.n = 8;
              break;
            }
            if (!(typeof game_mod.launchFromArcadeWizard === 'function')) {
              _context25.n = 4;
              break;
            }
            game_mod.launchFromArcadeWizard(options, invite_obj);
            return _context25.a(2);
          case 4:
            _context25.n = 5;
            return _this25.createOpenTransaction(gamedata);
          case 5:
            opentx = _context25.v;
            _this25.app.connection.emit('relay-send-message', {
              recipient: 'PEERS',
              request: 'arcade spv update',
              data: opentx.toJson()
            });
            _this25.addInviteRecord(opentx, 'private');
            _context25.n = 6;
            return _this25.createAcceptTransaction(opentx);
          case 6:
            newtx = _context25.v;
            if (newtx) {
              _context25.n = 7;
              break;
            }
            console.warn('ARCADE: createAcceptTransaction returned nothing; skipping propagate and lounge overlay');
            return _context25.a(2);
          case 7:
            _this25.app.network.propagateTransaction(newtx);
            _this25.app.connection.emit('relay-send-message', {
              recipient: 'PEERS',
              request: 'arcade spv update',
              data: newtx.toJson()
            });
            _this25.render('lounge_overlay', {
              game_id: opentx.signature
            });
            return _context25.a(2);
          case 8:
            open_invites = _this25.returnOpenInvites();
            if (!(open_invites.length > 0)) {
              _context25.n = 12;
              break;
            }
            _context25.n = 9;
            return sconfirm('You already have an open invite. Are you sure you want to create a new one?');
          case 9:
            c = _context25.v;
            if (c) {
              _context25.n = 10;
              break;
            }
            return _context25.a(2);
          case 10:
            _context25.n = 11;
            return sconfirm('Would you like to close the other invites?');
          case 11:
            c = _context25.v;
            if (c) {
              _iterator6 = _createForOfIteratorHelper(open_invites);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  game_id = _step6.value;
                  _this25.sendCancelTransaction(game_id);
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            }
          case 12:
            if (gameType == 'direct') {
              if (gamedata.players_needed > 2) {
                gamedata.invitation_type = 'open';
              } else {
                gamedata.invitation_type = 'private';
              }
            }
            _context25.n = 13;
            return _this25.createOpenTransaction(gamedata);
          case 13:
            _newtx = _context25.v;
            if (!(gameType == 'import')) {
              _context25.n = 14;
              break;
            }
            _this25.app.connection.emit('arcade-launch-game-import', _newtx);
            return _context25.a(2);
          case 14:
            _context25.n = 15;
            return _this25.app.network.propagateTransaction(_newtx);
          case 15:
            _this25.app.connection.emit('relay-send-message', {
              recipient: 'PEERS',
              request: 'arcade spv update',
              data: _newtx.toJson()
            });
            if (_this25.app.browser.isMobileBrowser(navigator.userAgent) && !_this25.browser_active) {
              siteMessage('creating game invite...', 1500);
            }
            _this25.game_timeout = setTimeout(function () {
              salert('Your browser may have broadcast that invite, but network seems unstable. Please refresh to confirm!');
            }, 10000);
          case 16:
            return _context25.a(2);
        }
      }, _callee24);
    }))();
  }
};